module.exports = __webpack_public_path__ + "static/assets/8f4c82c5fef3376d3adabf952b7d82b2.svg";